export const isScreenSmall = () => window.innerWidth <= 767

export const isScreenMedium = () =>
  window.innerWidth > 767 && window.innerWidth <= 1024

export const isScreenBig = () => window.innerWidth > 1024

export const isMobile = () => matchMedia('(max-width: 600px)').matches

export const getMargin = (size, isTop) =>
  size === 'Large'
    ? `u-margin${isTop ? 'Top' : 'Bottom'}12gu`
    : size === 'Medium'
      ? `u-margin${isTop ? 'Top' : 'Bottom'}8gu`
      : size === 'Small'
        ? `u-margin${isTop ? 'Top' : 'Bottom'}4gu`
        : size === 'Extra Small'
          ? `u-margin${isTop ? 'Top' : 'Bottom'}2gu`
          : ''

export const getMargins = (marginTop, marginBottom) =>
  `${getMargin(marginTop, true)} ${getMargin(marginBottom, false)}`
